var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaystack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4051_2093)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4051_2093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V23.6078H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4051_2093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5065 0H1.24675C0.56102 0 0 0.562078 0 1.2491V3.49745C0 4.18447 0.56102 4.74655 1.24675 4.74655H21.4442C22.1299 4.74655 22.6909 4.18447 22.6909 3.49745V1.2491C22.7533 0.562078 22.1922 0 21.5065 0ZM21.5065 12.5534H1.24675C0.56102 12.5534 0 13.1155 0 13.8025V16.0508C0 16.7378 0.56102 17.2999 1.24675 17.2999H21.4442C22.1299 17.2999 22.6909 16.7378 22.6909 16.0508V13.8025C22.7533 13.1155 22.1922 12.5534 21.5065 12.5534ZM12.6545 18.8613H1.24675C0.56102 18.8613 0 19.4234 0 20.1104V22.3587C0 23.0458 0.56102 23.6078 1.24675 23.6078H12.6545C13.3403 23.6078 13.9013 23.0458 13.9013 22.3587V20.1104C13.9013 19.4234 13.3403 18.8613 12.6545 18.8613ZM22.7533 6.30792H1.24675C0.56102 6.30792 0 6.87 0 7.55698V9.80537C0 10.4924 0.56102 11.0545 1.24675 11.0545H22.7533C23.439 11.0545 24 10.4924 24 9.80537V7.55698C24 6.87 23.439 6.30792 22.7533 6.30792Z",
    fill: "#0BA4DB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4051_2093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystack);
export default __webpack_public_path__ + "static/media/paystack.6e869554dc2af266e1b328fe7c86d488.svg";
export { ForwardRef as ReactComponent };